import React, { Component } from 'react';
import footer_logo from "assets/img/footer_logo.png";



class Footer extends Component{
  render(){
  	return(
    	<footer id="footer">
        <div className="container">
          <div className="row">
            <div className="col-md-3">
              <img src={footer_logo} alt="footerLogoImage" />
            </div>

            <div className="col-md-3">
              <h4 className="footer_heading">COMPANY INFO</h4>
              <ul className="footer_menus">
                <li><a href="/About_Us">About Us</a></li>
                <li><a href="/How_It_Works">How It Works</a></li>   
                <li><a href="/Adjudicator_Comments">Adjudicator Comments</a></li>
                <li><a href="/faq">FAQs</a></li>
              </ul>
            </div>

            <div className="col-md-3">
              <h4 className="footer_heading">Connect With us</h4>
              <ul className="footer_menus">
                <li>704-846-7870 ext. 205</li>
                <li>Info@musicadjudicator.com</li>  
                <li>8300 Fairview Rd. Charlotte NC 28227</li>
              </ul>
            </div>

            <div className="col-md-3">
              <h4 className="footer_heading">Terms &amp; Policies</h4>
              <ul className="footer_menus">
                { /*<li><a href="#!">Terms of Service</a></li>*/ }
                <li><a href="/privacycontact">Privacy Policy </a></li>  
                { /*<li><a href="#!">Security</a></li>*/}
              </ul>
            </div>
            {/*<div className="col-md-3">
              <h4 className="footer_heading">Follow On Social</h4>
              <ul className="social_icons">
                <li><a href="#!"><i className="fa fa-facebook"></i></a></li>
                <li><a href="#!"><i className="fa fa-dribbble"></i></a></li>
                <li><a href="#!"><i className="fa fa-twitter"></i></a></li>
                <li><a href="#!"><i className="fa fa-youtube"></i></a></li>
                <li><a href="#!"><i className="fa fa-vimeo"></i></a></li>
              </ul>
            </div>*/}
          </div>
        </div>

        <div className="sec_line mt-mb-sl"></div>

        <div className="container">
          <div className="row">
            <div className="col-md-12 text-center">
              Copyright &copy; {new Date().getFullYear()}{" "} <a href={'/'}>Music Adjudicator</a>
            </div>
            {
              /*
              <div className="col-md-6">
                <ul className="privacy center_block">
                  <li><a href="#!">Privacy Policy</a></li>  
                  <li><a href="#!">Cookie Policy    </a></li>
                  <li><a href="#!">Terms of Use</a></li>
                </ul>
              </div>
            */}
          </div>
        </div>
      </footer>
  	);
  }
}
export default Footer;


// WEBPACK FOOTER //
// ./src/components/FrontEnd/Footer/Footer.jsx